export const EMBED_GOOGLE_SLIDES_CONFIG = {
    name        : 'Google Slides',
    icon        : 'i5-google-slides',
    iconSvg     : 'isvg-google-slides',
    description : 'Embeded Google Slides',
    embedCode   : '',
    projectIcon : 'googleSlides',                   // from ConstItemIcon and ProjectIconDictionary

    keyWords    : ['docs.google.com/presentation']  // required for embedCode content search for autodetect EmbedType
}
